import React from "react";
import CRUDDetailPage from "../../../shared/components/crud/CRUDDetailPage";
import { childRecordConfig } from "../config/index";
import { ChildrenService } from "../../../shared/services/childrenService";

/**
 * ChildrenDetail - URL-based detail page for Children
 * Handles view, edit, and add modes with ID from URL params
 */
export default function ChildrenDetail() {
  return <CRUDDetailPage config={childRecordConfig} service={ChildrenService} />;
}
